import { Container, Row, Col, Card } from "react-bootstrap";
import {
  FaUserShield,
  FaClipboardList,
  FaFileAlt,
  FaMoneyBillWave,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";

export default function AboutThree() {
  const features = [
    {
      icon: <FaUserShield />,
      title: "User Access Management",
      text: "Create and manage user logins with role-based permissions.",
      bg: "bg-primary",
    },
    {
      icon: <FaClipboardList />,
      title: "Ticket Management",
      text: "Track and resolve field service requests efficiently.",
      bg: "bg-success",
    },
    {
      icon: <FaFileAlt />,
      title: "Custom FSR Reports",
      text: "Generate detailed field service reports as per your requirements.",
      bg: "bg-warning",
    },
    {
      icon: <FaClipboardList />,
      title: "Attendance & Leave Management",
      text: "Monitor employee attendance and leave records with ease.",
      bg: "bg-danger",
    },
    {
      icon: <FaMoneyBillWave />,
      title: "Expense Management",
      text: "Track and approve field-related expenses seamlessly.",
      bg: "bg-info",
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Employee Tracking",
      text: "Monitor real-time location and movement of field employees.",
      bg: "bg-secondary",
    },
  ];

  return (
    <Container className="my-5">
      <Row className="g-5">
        {features.map((feature, index) => (
          <Col md={4} key={index}>
            <Card className="shadow-lg border-0 p-4 text-center rounded-4 feature-card">
              <div
                className={`d-flex justify-content-center align-items-center ${feature.bg} text-white rounded-circle`}
                style={{
                  width: "60px",
                  height: "60px",
                  margin: "0 auto",
                  fontSize: "28px",
                }}
              >
                {feature.icon}
              </div>
              <Card.Body>
                <h5 className="fw-bold mt-2 text-dark">{feature.title}</h5>
                <p className="text-secondary">{feature.text}</p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
